/**
 * Mock Timetable Cycles and Periods
 */

import type { CpTimetableCycle, CpPeriod } from '../../../types/curriculum_planning';

const now = Date.now();

export const mockCpTimetableCycles: CpTimetableCycle[] = [
  {
    id: 'tc-2024-1week',
    name: 'Standard 1-Week Cycle',
    academicYearId: 'ay-2024-2025',
    cycleType: '1-week',
    periodsPerDay: 6,
    daysPerWeek: 5,
    periodDurationMinutes: 55,
    totalPeriodsPerCycle: 30,
    createdAt: now,
    updatedAt: now,
  },
  {
    id: 'tc-2025-2week',
    name: '2-Week Rotation Cycle',
    academicYearId: 'ay-2025-2026',
    cycleType: '2-week',
    periodsPerDay: 6,
    daysPerWeek: 5,
    periodDurationMinutes: 55,
    totalPeriodsPerCycle: 60,
    createdAt: now,
    updatedAt: now,
  },
];

// Generate periods for the 1-week cycle
const generatePeriods = (cycleId: string, isWeekA: boolean = true): CpPeriod[] => {
  const periods: CpPeriod[] = [];
  const weekType = isWeekA ? 'A' : 'B';
  const timeSlots = [
    { start: '08:45', end: '09:40', label: 'P1' },
    { start: '09:40', end: '10:35', label: 'P2' },
    { start: '10:55', end: '11:50', label: 'P3' },
    { start: '11:50', end: '12:45', label: 'P4' },
    { start: '13:30', end: '14:25', label: 'P5' },
    { start: '14:25', end: '15:20', label: 'P6' },
  ];

  for (let day = 1; day <= 5; day++) {
    timeSlots.forEach((slot, idx) => {
      periods.push({
        id: `period-${cycleId}-${weekType}-d${day}-p${idx + 1}`,
        timetableCycleId: cycleId,
        label: slot.label,
        dayOfWeek: day,
        weekType: cycleId.includes('2week') ? weekType : undefined,
        ordinalPosition: idx + 1,
        startTime: slot.start,
        endTime: slot.end,
        isBreak: false,
        createdAt: now,
      });
    });
  }

  return periods;
};

export const mockCpPeriods: CpPeriod[] = [
  ...generatePeriods('tc-2024-1week'),
  ...generatePeriods('tc-2025-2week', true),
  ...generatePeriods('tc-2025-2week', false),
];
